import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from 'common';
import { LocAgreementFormComponent } from './loc-agreement-form/loc-agreement-form.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LoanFundedDialogComponent } from '../loan/loan-funded-dialog/loan-funded-dialog.component';
import { DocuSignSignStepComponent } from './docusign-sign-step/docusign-sign-step.component';
import { DocuSignReturnComponent } from './docusign-return/docusign-return.component';
import { AgreementDocumentComponent } from './agreement-document/agreement-document.component';
import { AgreementDisclosureComponent } from './agreement-disclosure/agreement-disclosure.component';

@NgModule({
    imports: [
        SharedModule,
        CommonModule,
        RouterModule
    ],
    declarations: [
        LocAgreementFormComponent,
        LoanFundedDialogComponent,
        DocuSignSignStepComponent,
        DocuSignReturnComponent,
        AgreementDocumentComponent,
        AgreementDisclosureComponent
    ],
    exports: [
        DocuSignSignStepComponent,
        DocuSignReturnComponent
    ],
    schemas: [NO_ERRORS_SCHEMA]
})
export class LocAgreementModule { }
